export default {
    general: {
        type: ['CAR', 'PUBLIC']
    },
    car: {
        travelMode: 'FASTEST',
        avoid: {
            motorway: false,
            vignette: false,
            toll: false,
            ferry: false,
        },
        avoidTunnels: '',
        avoidCountries: [],
    },
    bike: {
        bikeParameters: {
            avoidInclines: false,
            preferCyclingInfrastructure: true,
        }
    },
    camper: {
        travelMode: 'FASTEST',
        avoid: {
            motorway: false,
            vignette: false,
            toll: false,
            ferry: false,
        },
        avoidTunnels: '',
        avoidCountries: [],
    },
    trailer: {
        travelMode: 'FASTEST',
        avoid: {
            motorway: false,
            vignette: false,
            toll: false,
            ferry: false,
        },
        avoidTunnels: '',
        avoidCountries: [],
    },
    motorcycle: {
        travelMode: 'FASTEST',
        avoid: {
            motorway: false,
            vignette: false,
            toll: false,
            ferry: false,
        },
        avoidTunnels: '',
        avoidCountries: [],
    },
    public: {
        meansOfTransport: ['CABLE_COG_RAILWAY', 'CALL_PICKUP_TAXI_BUS', 'CITY_BUS', 'EXPRESS_BUS', 'OTHER', 'REGIONAL_BUS', 'SHIP', 'TRAIN', 'TRAM', 'UNDERGROUND_RAILWAY'],
        avoidBarriers: [],
        maxChanges: '-1',
        other: {
            bikeCarriage: false,
        }
    },
    sharing: {
        noLicence: ['CITYBIKE', 'NEXTBIKE', 'TIER'],
        licence: ['CARUSO', 'FLOMOBIL']
    }
}